import { useQuery } from '@apollo/client';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import useInfiniteDataQuery from 'hooks/useInfiniteDataQuery';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { GET_COMPANY_LOCATION } from 'services/graphql/queries/location.query';
import { GET_TRANSACTION } from 'services/graphql/queries/transactions.query';
import { GET_USER_SERVICE_TYPE_AND_LOCATIONS } from 'services/graphql/queries/user.query';
import { ITransactionType } from 'types/services';
import { ITransaction } from 'types/transaction';
import { CompanyRoleEnum, IUser } from 'types/user';

export const useTransactionRelatedProps = (cloneTransactionId?: string) => {
  const history = useHistory();
  const params: Record<string, string> = useParams();
  const transactionIdFromParams = params?.id;
  const transactionId = transactionIdFromParams || cloneTransactionId || history.location.state || '';
  const { id: userId, companyRole } = useCurrentLoggedInUser(); // test nha

  const { data, loading: transactionLoading, refetch } = useQuery<{ findOneTransactionEntity: ITransaction }>(
    GET_TRANSACTION,
    {
      skip: !transactionId,
      variables: {
        id: transactionId,
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      pollInterval: 60000,
    },
  );

  const transactionData = data?.findOneTransactionEntity;

  const { data: userData, loading: userDataLoading } = useQuery<{ findOneUserEntity: IUser }>(
    GET_USER_SERVICE_TYPE_AND_LOCATIONS,
    {
      variables: {
        id: userId,
        user: userId,
      },
    },
  );

  const user = userData?.findOneUserEntity;

  const serviceTypesData = user?.company?.serviceTypes;
  const transactionTypesData = serviceTypesData?.reduce(
    (acc: ITransactionType[], service) => acc.concat(service.transactionTypes),
    [],
  );

  const { data: locationsData, loading: locationLoading, fetchNextPageData } = useInfiniteDataQuery({
    graphQLQuery: GET_COMPANY_LOCATION,
    queryProps: {
      variables: {
        pagination: { take: 50 },
      },
      skip: companyRole !== CompanyRoleEnum.ADMIN,
    },
  });

  const userPermittedLocationsData =
    companyRole !== CompanyRoleEnum.ADMIN ? user?.usersLocations?.map((uL) => uL.location) : locationsData;

  useEffect(() => {
    if (data && !userDataLoading) {
      refetch();
    }
  }, [history.location.pathname]);

  return {
    userPermittedLocationsData,
    transactionTypesData,
    transactionData,
    userDataLoading,
    transactionLoading,
    locationLoading,
    refetchTransactionData: refetch,
    transactionId: transactionIdFromParams,
    fetchNextPageLocationData: fetchNextPageData,
  };
};
